
import { fetchAuthSession } from "aws-amplify/auth";
import { Hub } from "aws-amplify/utils";
import React from "react";
import { useNavigate } from "react-router";
import { useEffect ,useState} from "react";
import AccessDenied from "./AccessDenied";
import { fetchAccessRoles } from "../Utils/api";



function AuthCallback() {
  const navigate = useNavigate();
  const [accessDenied,setAccessDenied] = useState(false);

    useEffect(() => {
        async function handleCallback() {
            try {
                let authSession = await fetchAuthSession();
                if(authSession?.tokens?.accessToken){
                    const roles = await fetchAccessRoles();
                    const accessToken = authSession?.tokens?.accessToken?.payload;
                    const admin = roles.filter(accessRole=> accessRole.role==='Admin')
                    const owner = roles.filter(accessRole=>accessRole.role==="Owner" || accessRole.role=== 'Co-Owner')
                    const accessGroups = accessToken['cognito:groups'];
                    if(admin.some(accessRole =>accessGroups.includes(accessRole.securityGroup)) || owner.some(accessRole=>accessGroups.includes(accessRole.securityGroup))){
                        navigate("/dash")
                    }else{
                        setAccessDenied(true);
                    }
                }
            } catch (err) {
                console.error("Auth callback error:", err);
                setAccessDenied(true);
            }
        }

        const unsubscribe = Hub.listen("auth", ({ payload }) => {
            if (payload.event === "signInWithRedirect") {
                handleCallback();
            }
            if (payload.event === "signInWithRedirect_failure") {
                setAccessDenied(true);
            }
        });

        // Also attempt immediately in case tokens are already available
        handleCallback();

        return () => unsubscribe();
    }, [])
    return (
        <>
            {accessDenied && <AccessDenied/>}
        </>
    );

}

export default AuthCallback;